import { render, staticRenderFns } from "./sos.vue?vue&type=template&id=6d957618&scoped=true"
import script from "./sos.vue?vue&type=script&lang=js"
export * from "./sos.vue?vue&type=script&lang=js"
import style0 from "./sos.vue?vue&type=style&index=0&id=6d957618&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d957618",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d957618')) {
      api.createRecord('6d957618', component.options)
    } else {
      api.reload('6d957618', component.options)
    }
    module.hot.accept("./sos.vue?vue&type=template&id=6d957618&scoped=true", function () {
      api.rerender('6d957618', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/mdInfo/components/sos.vue"
export default component.exports